import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEO from "@/components/SEO";
import { useStaticTranslation } from "@/hooks/useTranslation";

const NotFound = () => {
  const location = useLocation();
  const { t } = useStaticTranslation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const isArabic = location.pathname.startsWith("/ar");

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <SEO title={t("Page Not Found")} noindex />
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t("Oops! Page not found")}</p>
        <a href={isArabic ? "/ar" : "/"} className="text-primary underline hover:text-primary/80">
          {t("Return to Home")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
